import { CampaignsIcon } from 'foundations-assets/icons/components/CampaignsIcon';
import { HubDBIcon } from 'foundations-assets/icons/components/HubDBIcon';
import { LayersIcon } from 'foundations-assets/icons/components/LayersIcon';
import { QuestionAnswerIcon } from 'foundations-assets/icons/components/QuestionAnswerIcon';
import { WorkflowsIcon } from 'foundations-assets/icons/components/WorkflowsIcon';
const HUB_TYPE_ICONS = {
  'marketing-hub': CampaignsIcon,
  'sales-hub': WorkflowsIcon,
  'service-hub': QuestionAnswerIcon,
  'commerce-hub': WorkflowsIcon,
  'cms-hub': LayersIcon,
  'content-hub': LayersIcon,
  'data-hub': HubDBIcon,
  'operations-hub': HubDBIcon,
  'marketing-plus': [LayersIcon, CampaignsIcon]
};
export const getIconForBullet = (apiName, bulletIndex = 0) => {
  for (const hubType in HUB_TYPE_ICONS) {
    if (apiName !== null && apiName !== void 0 && apiName.includes(hubType)) {
      const iconValue = HUB_TYPE_ICONS[hubType];
      if (Array.isArray(iconValue)) {
        return iconValue[bulletIndex] || iconValue[0];
      }
      return iconValue;
    }
  }
  return LayersIcon;
};